import React from 'react';
import { useApp } from '../../context/AppContext';
import { examinerScope } from '../../utils/examinerApi';
import ExaminerSession from './ExaminerSession';
import './examiner.css';
import useExaminerVisibility from '../../utils/useExaminerVisibility';

const MockExaminer = () => {
  const { currentUser, currentOrg } = useApp();
  const showExaminer = useExaminerVisibility();
  if (!showExaminer) return null;
  if (!currentUser?.sessionId) return <p>Sign in to access the AI Mock Oral Examiner.</p>;
  return <div className="examiner" key={`${examinerScope(currentUser)}:${currentOrg?.id}`}><ExaminerSession /></div>;
};
export default MockExaminer;
